const DEFAULT_MIMETYPE = 'image/png'
const DEFAULT_IMAGE_TYPE = 'png'

export const getImageTypeFromBase64 = (base64String: string) => {
  const mimeType = getMimeTypeFromBase64(base64String)
  const mime = mimeType.split('/')

  return mime.length > 0 ? mime[1] : DEFAULT_IMAGE_TYPE
}

const getMimeTypeFromBase64 = (base64String: string) => {
  const match = base64String.match(/^data:(.+);base64,/)
  return match ? match[1] : DEFAULT_MIMETYPE
}

const base64ToBlob = (base64: string, mimeType: string) => {
  const byteCharacters = atob(base64)
  const byteNumbers = new Array(byteCharacters.length)
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i)
  }
  const byteArray = new Uint8Array(byteNumbers)
  return new Blob([byteArray], { type: mimeType })
}

export const downloadBase64Image = (base64String: string, filename: string) => {
  const mimeType = getMimeTypeFromBase64(base64String)
  // Supprimer le préfixe "data:image/png;base64,"
  const base64Data = base64String.split(',')[1]

  // Convertir en Blob
  const blob = base64ToBlob(base64Data, mimeType)
  const url = URL.createObjectURL(blob)

  // Créer et simuler un clic sur un lien de téléchargement
  const tempLink = document.createElement('a')
  tempLink.href = url
  tempLink.setAttribute('download', `${filename}.${mimeType.split('/')[1]}`)
  document.body.appendChild(tempLink)
  tempLink.click()
  document.body.removeChild(tempLink)
  URL.revokeObjectURL(url)
}
